module.exports = __webpack_public_path__ + "img/logo_mark_color.192aa612.svg";